import { MobileAppDashboardThumbDetails } from './mobile-app-dashboard-thumb-details.model';
import { EmployeeWorkingDays } from './employee-working-days.model';
import { AttendanceSummary } from './attendance-summary.model';


export class MobileAppDashboard implements IMobileAppDashboard {
    mobileAppDashboardThumbDetails!: MobileAppDashboardThumbDetails[] | undefined;
    employeeWorkingDays!: EmployeeWorkingDays[] | undefined;
    attendanceSummary!: AttendanceSummary[] | undefined;

    constructor(data?: IMobileAppDashboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mobileAppDashboardThumbDetails"])) {
                this.mobileAppDashboardThumbDetails = [] as any;
                for (let item of _data["mobileAppDashboardThumbDetails"])
                    this.mobileAppDashboardThumbDetails!.push(MobileAppDashboardThumbDetails.fromJS(item));
            }
            if (Array.isArray(_data["employeeWorkingDays"])) {
                this.employeeWorkingDays = [] as any;
                for (let item of _data["employeeWorkingDays"])
                    this.employeeWorkingDays!.push(EmployeeWorkingDays.fromJS(item));
            }
            if (Array.isArray(_data["attendanceSummary"])) {
                this.attendanceSummary = [] as any;
                for (let item of _data["attendanceSummary"])
                    this.attendanceSummary!.push(AttendanceSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MobileAppDashboard {
        data = typeof data === 'object' ? data : {};
        let result = new MobileAppDashboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mobileAppDashboardThumbDetails)) {
            data["mobileAppDashboardThumbDetails"] = [];
            for (let item of this.mobileAppDashboardThumbDetails)
                data["mobileAppDashboardThumbDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.employeeWorkingDays)) {
            data["employeeWorkingDays"] = [];
            for (let item of this.employeeWorkingDays)
                data["employeeWorkingDays"].push(item.toJSON());
        }
        if (Array.isArray(this.attendanceSummary)) {
            data["attendanceSummary"] = [];
            for (let item of this.attendanceSummary)
                data["attendanceSummary"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IMobileAppDashboard {
    mobileAppDashboardThumbDetails: MobileAppDashboardThumbDetails[] | undefined;
    employeeWorkingDays: EmployeeWorkingDays[] | undefined;
    attendanceSummary: AttendanceSummary[] | undefined;
}

